<template>
    <div>
        <Header :label="fullName" overlap="small" />
        <UserNavSection />

        <router-view v-if="hasAssessments" />
        <div v-else slot="center">
            <iframe
                class="wrapper-thing"
                src="https://docs.google.com/forms/d/e/1FAIpQLSf8YE5-RMVBe3D7x03chBNp7-aZweMJelDIH6Hc9IuUdBPmAA/viewform?embedded=true"
                frameborder="0"
                marginheight="0"
                marginwidth="0"
            >
                Loading...
            </iframe>
        </div>
    </div>
</template>

<script>
// Project components
import Header from '~/components/layouts/Header';
import UserNavSection from '~/shared/UserNavSection';
import userDataToName from '~/utils/user/userDataToName';

export default {
    name: 'Tests',
    components: {
        Header,
        UserNavSection,
    },
    data: () => ({
        hasAssessments: true,
    }),
    computed: {
        userData() {
            return this.$interfaces.user.me.get({ reactive: true });
        },
        fullName() {
            return userDataToName(this.userData.data || {}, 'tests.header');
        },
    },
};
</script>

<style scoped>
.wrapper-thing {
    margin-top: 10px;
    border: none;
    width: 100%;
    height: 580px;
}
.warning-paper {
    position: relative;
}
.poster {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 40%;
}
.poster-img {
    width: 100%;
    height: 100%;
    object-fit: cover;

    -webkit-clip-path: polygon(0 0, 100% 0, 79% 100%, 0% 100%);
    clip-path: polygon(0 0, 100% 0, 79% 100%, 0% 100%);
}
</style>
